import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import {AuthGuard, Verified} from './shared/security/auth.guard';
// Import Containers
import {
  FullLayoutComponent,
  // SimpleLayoutComponent
} from './containers';
import {SimpleLayoutComponent} from "./containers/simple-layout";
import {AdminGuard, AuthGuard, PartnerGuard} from './shared/security/auth.guard';


export const routes: Routes = [
  {
    path: '',
    redirectTo: '/devices',
    pathMatch: 'full',
  },
  {
    path: '',
    component: FullLayoutComponent,
    data: {
      title: 'Home'
    },
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'clients',
        loadChildren: './views/clients/clients.module#ClientsModule',
        // canActivate: [PartnerGuard]
      },
      {
        path: 'partners',
        loadChildren: './views/partners/partners.module#PartnersModule',
        // canActivate: [AdminGuard]
      },
      {
        path: 'devices',
        loadChildren: './views/devices/devices.module#DevicesModule'
      },
      // {
      //   path: 'historics',
      //   loadChildren: './views/historics/historics.module#HistoricsModule'
      // },
      // {
      //   path: 'bills-receive',
      //   loadChildren: './views/bills-receive/bills-receive.module#BillsReceiveModule'
      // },
      // {
      //   path: 'bills-pay',
      //   loadChildren: './views/bills-pay/bills-pay.module#BillsPayModule'
      // },
      // {
      //   path: 'demands',
      //   loadChildren: './views/demands/demands.module#DemandsModule'
      // },
      // {
      //   path: 'demands/new',
      //   loadChildren: './views/new-demands/new-demands.module#NewDemandsModule'
      // },
      // {
      //   path: 'my_account',
      //   loadChildren: './views/my-account/my-account.module#MyAccountModule'
      // },
      // {
      //   path: 'support',
      //   loadChildren: './views/support/support.module#SupportModule'
      // },
      // {
      //   path: 'partners',
      //   loadChildren: './views/partners/partners.module#PartnersModule'
      // },
    ]
  },
  {
    path: 'pages',
    component: SimpleLayoutComponent,
    data: {
      title: 'Pages'
    },
    children: [
      {
        path: '',
        loadChildren: './views/pages/pages.module#PagesModule',
      }
    ]
  },
  // {
  //   path: 'mobile',
  //   redirectTo: 'pages/mobile',
  //   pathMatch: 'full',
  // },
  {
    path: '**',
    redirectTo: 'login'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/Users/bruna/Desktop/nuresp/src/app/app.routing.ts